var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTimer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#5F59FF",
    d: "M10.34 1H7.67a.67.67 0 0 0 0 1.33h2.67a.67.67 0 0 0 0-1.33ZM9 9.67c.37 0 .67-.3.67-.67V6.33a.67.67 0 0 0-1.33 0V9c0 .37.3.67.66.67Zm4.69-4.41.5-.5a.66.66 0 0 0 0-.93v-.01a.66.66 0 0 0-.94 0l-.5.5A5.97 5.97 0 0 0 9 3a6 6 0 1 0 4.69 2.26ZM9 13.66a4.66 4.66 0 1 1 0-9.32 4.66 4.66 0 0 1 0 9.33Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimer);
export default __webpack_public_path__ + "static/media/timer.bcd65cdc.svg";
export { ForwardRef as ReactComponent };